import { DefaultToastOptions } from 'react-hot-toast'

export const toastOptions: DefaultToastOptions = {
  className: 'toast-animation',
  style: {
    background: '#fff',
    color: '#000',
    padding: '24px 28px',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    maxWidth: '500px',
    direction: 'rtl' as const,
    fontSize: '18px',
    fontWeight: '500',
    border: '2px solid transparent',
    animation: 'slideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    position: 'relative',
    overflow: 'hidden',
  },
  success: {
    style: {
      background: 'rgba(16, 185, 129, 0.95)',
      color: '#fff',
      border: '2px solid #059669',
      boxShadow: '0 20px 25px -5px rgba(16, 185, 129, 0.3), 0 10px 10px -5px rgba(16, 185, 129, 0.2)',
    },
    iconTheme: {
      primary: '#fff',
      secondary: '#059669',
    },
    className: 'toast-success',
  },
  error: {
    style: {
      background: 'rgba(239, 68, 68, 0.95)',
      color: '#fff',
      border: '2px solid #DC2626',
      boxShadow: '0 20px 25px -5px rgba(239, 68, 68, 0.3), 0 10px 10px -5px rgba(239, 68, 68, 0.2)',
    },
    iconTheme: {
      primary: '#fff',
      secondary: '#DC2626',
    },
    className: 'toast-error',
  },
  loading: {
    style: {
      background: 'rgba(59, 130, 246, 0.95)',
      color: '#fff',
      border: '2px solid #2563EB',
      boxShadow: '0 20px 25px -5px rgba(59, 130, 246, 0.3), 0 10px 10px -5px rgba(59, 130, 246, 0.2)',
    },
    className: 'toast-loading',
  },
  duration: 1500,
} 